/**
 * DirectionsSection — 5 course-direction tiles (零基础/考试/商务/留学/兴趣
 * 以及 K12 教材联动 + 自创课). Renders course-direction emoji via Twemoji
 * for cross-platform consistency.
 */
import { Emoji } from '@/components/Emoji';
import { Reveal } from '@/components/Reveal';
import { SectionHeading } from '@/components/SectionHeading';
import { DIRECTIONS } from '@/lib/data';

export function HomeDirections(): JSX.Element {
  return (
    <section className="relative py-24 md:py-32 border-t border-honey-400/10">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Course Market · 全库 1000+"
            title={<>不管你为什么学， <span className="text-gradient-warm">都有一条路径</span></>}
            subtitle="K12 教材同步、应试冲刺、商务邮件、留学生存、影视台词 — 还能自己造课"
          />
        </Reveal>

        <div className="mt-14 grid gap-4 md:grid-cols-4 lg:grid-cols-7">
          {DIRECTIONS.map((d, i) => (
            <Reveal key={d.key} delay={i * 0.04}>
              <div className="group h-full rounded-3xl border border-honey-400/15 bg-ink-900/40 p-5 transition-all hover:border-honey-400/40 hover:-translate-y-1">
                <div className={`mb-3 inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br ${d.gradient}`}>
                  <Emoji char={d.emoji} size={22} />
                </div>
                <div className="font-display font-bold text-white text-sm">{d.title}</div>
                <p className="mt-1 text-[11px] text-cream-400 leading-relaxed">{d.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
